import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

// This publicRoutes uses a blank layout
export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "login-1",
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-1")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "role-selection",
    path: `${AUTH_PREFIX_PATH}/role-selection`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/role-selection")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "register-1",
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-1")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "otp-input",
    path: `${AUTH_PREFIX_PATH}/otp-input`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/otp-input")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "forget-email-otp-input",
    path: `${AUTH_PREFIX_PATH}/forget-email-otp-input`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forget-email-otp-input")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "new-password",
    path: `${AUTH_PREFIX_PATH}/new-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/new-password")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "profile-setup",
    path: `${AUTH_PREFIX_PATH}/profile-setup`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/profile-setup")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "business-profile-setup",
    path: `${AUTH_PREFIX_PATH}/business-profile-setup`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/business-profile-setup")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "account-success",
    path: `${AUTH_PREFIX_PATH}/account-success`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/account-success")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "onboarding-agreement",
    path: `${AUTH_PREFIX_PATH}/onboarding-agreement`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/onboarding-agreement")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "choose-plan",
    path: `${AUTH_PREFIX_PATH}/subscription-plan`,
    component: React.lazy(() =>
      import("views/app-views/components/subscription-card/ChoosePlan")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "account-activate",
    path: `${AUTH_PREFIX_PATH}/account-activate`,
    component: React.lazy(() =>
      import("views/app-views/components/account-activation")
    ),
    meta: { blankLayout: true },
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: { blankLayout: true },
  },

  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
    meta: { blankLayout: true },
  },
];

export const protectedRoutes = [
  {
    key: "mechanic.services",
    path: `${APP_PREFIX_PATH}/mechanic/services`,
    component: React.lazy(() => import("views/app-views/mechanic/Services")),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.add-new-service",
    path: `${APP_PREFIX_PATH}/mechanic/add-new-service`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/AddNewService")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.service-detail",
    path: `${APP_PREFIX_PATH}/mechanic/service-details/:id`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/MechanicServiceDetail")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.service-edit",
    path: `${APP_PREFIX_PATH}/mechanic/service-edit/:id`,
    component: React.lazy(() => import("views/app-views/mechanic/EditService")),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.ads-analytics",
    path: `${APP_PREFIX_PATH}/mechanic/ads-analytics`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/AdsAnalytics")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.ad-detail",
    path: `${APP_PREFIX_PATH}/mechanic/ad-detail/:serviceId`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/AdDetail")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },

  // Announcements — visible to all roles
  {
    key: "announcements",
    path: `${APP_PREFIX_PATH}/announcements`,
    component: React.lazy(() =>
      import("views/app-views/announcements/Announcements")
    ),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner", "driver", "mechanic"],
    },
  },

  {
    key: "fleet-dashboard.home",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/home`,
    component: React.lazy(() => import("views/app-views/fleet-dashboard/home")),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner"],
      requiresVerification: true,
    },
  },
  {
    key: "fleet-dashboard.liveTracking",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/live-tracking`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/liveTracking")
    ),
    meta: {
      // Live Tracking is fleet-manager-only (not truck owners)
      allowedRoles: ["fleet_manager"],
      requiresVerification: true,
    },
  },
  {
    key: "truck-owner.home",
    path: `${APP_PREFIX_PATH}/truck_owner/home`,
    // Reuse fleet dashboard component for truck_owner home for now
    component: React.lazy(() => import("views/app-views/fleet-dashboard/home")),
    meta: { allowedRoles: ["truck_owner"], requiresVerification: true },
  },
  {
    key: "fleet-dashboard.addVehicle",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/add-vehicle`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/addVehicle")
    ),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner"],
      requiresVerification: true,
    },
  },
  {
    key: "fleet-dashboard.addDriver",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/add-driver`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/addDriver")
    ),
    meta: { allowedRoles: ["fleet_manager"], requiresVerification: true },
  },
  {
    key: "fleet-dashboard.editDriver",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/edit-driver/:id`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/editDriver")
    ),
    meta: { allowedRoles: ["fleet_manager"], requiresVerification: true },
  },
  {
    key: "fleet-dashboard.vehicleDetails",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/vehicle-details/:vehicleId`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/vehicleDetails")
    ),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner"],
      requiresVerification: true,
    },
  },
  {
    key: "fleet-dashboard.editVehicle",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/edit-vehicle/:id`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/editVehicle")
    ),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner"],
      requiresVerification: true,
    },
  },
  {
    key: "fleet-dashboard.driverDetails",
    path: `${APP_PREFIX_PATH}/fleet-dashboard/driver-details/:driverId`,
    component: React.lazy(() =>
      import("views/app-views/fleet-dashboard/driverDetails")
    ),
    meta: { allowedRoles: ["fleet_manager"], requiresVerification: true },
  },
  {
    key: "trip-planning",
    path: `${APP_PREFIX_PATH}/trip-planning`,
    component: React.lazy(() => import("views/app-views/trip-planning")),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner", "driver"],
    },
  },
  {
    key: "emergency-services",
    path: `${APP_PREFIX_PATH}/emergency-services`,
    component: React.lazy(() => import("views/app-views/emergency-services")),
    meta: {
      allowedRoles: ["fleet_manager", "truck_owner", "driver"],
    },
  },
  {
    key: "driver.home",
    path: `${APP_PREFIX_PATH}/driver/home`,
    component: React.lazy(() => import("views/app-views/driver/home")),
    meta: { allowedRoles: ["driver"] },
  },
  {
    key: "driver.my-trips",
    path: `${APP_PREFIX_PATH}/driver/my-trips`,
    component: React.lazy(() => import("views/app-views/driver/my-trips")),
    meta: { allowedRoles: ["driver"] },
  },
  {
    key: "driver.earnings",
    path: `${APP_PREFIX_PATH}/driver/earnings`,
    component: React.lazy(() => import("views/app-views/driver/earnings")),
    meta: { allowedRoles: ["driver"] },
  },
  {
    key: "bookings",
    path: `${APP_PREFIX_PATH}/bookings/home`,
    component: React.lazy(() => import("views/app-views/bookings/home")),
    meta: { allowedRoles: ["truck_owner", "fleet_manager", "driver"] },
  },
  {
    key: "booking-details",
    path: `${APP_PREFIX_PATH}/bookings/booking-details/:id`,
    component: React.lazy(() =>
      import("views/app-views/bookings/booking-details")
    ),
    meta: { allowedRoles: ["truck_owner", "fleet_manager", "driver"] },
  },
  {
    key: "booking-details",
    path: `${APP_PREFIX_PATH}/bookings/cancellation-confirmation`,
    component: React.lazy(() =>
      import(
        "../components/shared-components/CancelConformationModel/CancelConformation"
      )
    ),
  },
  {
    key: "booking-signing-doc",
    path: `${APP_PREFIX_PATH}/bookings/sign`,
    component: React.lazy(() =>
      import("views/app-views/bookings/review-and-sign")
    ),
  },
  {
    key: "booking-send-document-from",
    path: `${APP_PREFIX_PATH}/bookings/send-document-form`,
    component: React.lazy(() =>
      import("views/app-views/bookings/send-document-form")
    ),
  },
  {
    key: "booking-signature-form",
    path: `${APP_PREFIX_PATH}/bookings/signature`,
    component: React.lazy(() =>
      import("views/app-views/bookings/signature/SignatureForm")
    ),
  },
  {
    key: "booking-signing-completed",
    path: `${APP_PREFIX_PATH}/bookings/signing-completed`,
    component: React.lazy(() =>
      import("views/app-views/bookings/signing-completed/SigningCompleted")
    ),
  },
  {
    key: "booking-leave-review",
    path: `${APP_PREFIX_PATH}/bookings/review`,
    component: React.lazy(() =>
      import("views/app-views/bookings/review/LeaveReview")
    ),
  },
  {
    key: "booking-create-dispute",
    path: `${APP_PREFIX_PATH}/bookings/create-dispute`,
    component: React.lazy(() =>
      import("views/app-views/bookings/create-dispute")
    ),
    meta: { allowedRoles: ["fleet_manager", "truck_owner", "driver"] },
  },
  {
    key: "booking-dispute-details",
    path: `${APP_PREFIX_PATH}/bookings/dispute-details/:disputeId`,
    component: React.lazy(() =>
      import("views/app-views/bookings/dispute-details")
    ),
    meta: { allowedRoles: ["fleet_manager", "truck_owner", "driver"] },
  },
  {
    key: "booking-view-evidence",
    path: `${APP_PREFIX_PATH}/bookings/view-evidence`,
    component: React.lazy(() =>
      import("views/app-views/bookings/view-evidence")
    ),
    meta: { allowedRoles: ["fleet_manager", "truck_owner", "driver"] },
  },
  {
    key: "all-services",
    path: `${APP_PREFIX_PATH}/services/all`,
    component: React.lazy(() => import("views/app-views/services/AllServices")),
    meta: { allowedRoles: ["driver", "truck_owner", "fleet_manager"] },
  },

  {
    key: "mechanic.dashboard",
    path: `${APP_PREFIX_PATH}/mechanic/dashboard`,
    component: React.lazy(() => import("views/app-views/mechanic/Dashboard")),
    meta: { allowedRoles: ["mechanic"] },
  },
  // {
  //   key: "business-profile-setup",
  //   path: `${APP_PREFIX_PATH}/mechanic/business-profile-setup`,
  //   component: React.lazy(() =>
  //     import("views/auth-views/authentication/business-profile-setup")
  //   ),
  //   meta: { allowedRoles: ["mechanic"] },
  // },
  {
    key: "mechanic.bookings",
    path: `${APP_PREFIX_PATH}/mechanic/bookings`,
    component: React.lazy(() => import("views/app-views/mechanic/Bookings")),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.booking-details",
    path: `${APP_PREFIX_PATH}/mechanic/booking-details/:id`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/BookingDetails")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.dispute-details",
    path: `${APP_PREFIX_PATH}/mechanic/dispute-details`,
    component: React.lazy(() => import("views/app-views/mechanic/DisputeView")),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.submit-evidence",
    path: `${APP_PREFIX_PATH}/mechanic/submit-evidence`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/DisputeDetails")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "mechanic.additional-services",
    path: `${APP_PREFIX_PATH}/mechanic/additional-services`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/AdditionalServices")
    ),
  },
  {
    key: "mechanic.service-approved",
    path: `${APP_PREFIX_PATH}/mechanic/service-approved`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/ServiceApproved")
    ),
  },
  {
    key: "mechanic.evidence-success",
    path: `${APP_PREFIX_PATH}/mechanic/evidence-success`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/EvidenceSuccess")
    ),
  },
  {
    key: "wallet",
    path: `${APP_PREFIX_PATH}/wallet`,
    component: React.lazy(() => import("views/app-views/mechanic/MyWallet")),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "transaction-history",
    path: `${APP_PREFIX_PATH}/transaction-history`,
    component: React.lazy(() =>
      import("views/app-views/mechanic/TransactionHistory")
    ),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "dashboard.analytic",
    path: `${APP_PREFIX_PATH}/dashboards/analytic`,
    component: React.lazy(() => import("views/app-views/dashboards/analytic")),
  },
  {
    key: "dashboard.sales",
    path: `${APP_PREFIX_PATH}/dashboards/sales`,
    component: React.lazy(() => import("views/app-views/dashboards/sales")),
  },
  {
    key: "apps",
    path: `${APP_PREFIX_PATH}/apps`,
    component: React.lazy(() => import("views/app-views/apps")),
  },
  {
    key: "apps.mail",
    path: `${APP_PREFIX_PATH}/apps/mail/*`,
    component: React.lazy(() => import("views/app-views/apps/mail")),
  },
  {
    key: "apps.chat",
    path: `${APP_PREFIX_PATH}/apps/chat/*`,
    component: React.lazy(() => import("views/app-views/apps/chat")),
  },
  {
    key: "apps.calendar",
    path: `${APP_PREFIX_PATH}/apps/calendar`,
    component: React.lazy(() => import("views/app-views/apps/calendar")),
  },
  {
    key: "apps.project",
    path: `${APP_PREFIX_PATH}/apps/project`,
    component: React.lazy(() => import("views/app-views/apps/project")),
  },
  {
    key: "apps.project.list",
    path: `${APP_PREFIX_PATH}/apps/project/list`,
    component: React.lazy(() =>
      import("views/app-views/apps/project/project-list/ProjectList")
    ),
  },
  {
    key: "apps.project.scrumboard",
    path: `${APP_PREFIX_PATH}/apps/project/scrumboard`,
    component: React.lazy(() =>
      import("views/app-views/apps/project/scrumboard")
    ),
  },
  {
    key: "apps.ecommerce",
    path: `${APP_PREFIX_PATH}/apps/ecommerce`,
    component: React.lazy(() => import("views/app-views/apps/e-commerce")),
  },
  {
    key: "apps.ecommerce.add-product",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/add-product`,
    component: React.lazy(() =>
      import("views/app-views/apps/e-commerce/add-product")
    ),
  },
  {
    key: "apps.ecommerce.edit-product",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/edit-product/:id`,
    component: React.lazy(() =>
      import("views/app-views/apps/e-commerce/edit-product")
    ),
  },
  {
    key: "apps.ecommerce.product-list",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/product-list`,
    component: React.lazy(() =>
      import("views/app-views/apps/e-commerce/product-list")
    ),
  },
  {
    key: "apps.ecommerce.orders",
    path: `${APP_PREFIX_PATH}/apps/ecommerce/orders`,
    component: React.lazy(() =>
      import("views/app-views/apps/e-commerce/orders")
    ),
  },
  {
    key: "components.general",
    path: `${APP_PREFIX_PATH}/components/general`,
    component: React.lazy(() => import("views/app-views/components/general")),
  },
  {
    key: "components.general.button",
    path: `${APP_PREFIX_PATH}/components/general/button`,
    component: React.lazy(() =>
      import("views/app-views/components/general/button")
    ),
  },
  {
    key: "components.general.icon",
    path: `${APP_PREFIX_PATH}/components/general/icon`,
    component: React.lazy(() =>
      import("views/app-views/components/general/icon")
    ),
  },
  {
    key: "components.general.typography",
    path: `${APP_PREFIX_PATH}/components/general/typography`,
    component: React.lazy(() =>
      import("views/app-views/components/general/typography")
    ),
  },
  {
    key: "components.general",
    path: `${APP_PREFIX_PATH}/components/layout`,
    component: React.lazy(() => import("views/app-views/components/layout")),
  },
  {
    key: "components.general.grid",
    path: `${APP_PREFIX_PATH}/components/layout/grid`,
    component: React.lazy(() =>
      import("views/app-views/components/layout/grid")
    ),
  },
  {
    key: "components.general.layout",
    path: `${APP_PREFIX_PATH}/components/layout/layout`,
    component: React.lazy(() =>
      import("views/app-views/components/layout/layout")
    ),
  },
  {
    key: "components.navigation",
    path: `${APP_PREFIX_PATH}/components/navigation`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation")
    ),
  },
  {
    key: "components.navigation.affix",
    path: `${APP_PREFIX_PATH}/components/navigation/affix`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation/affix")
    ),
  },
  {
    key: "components.navigation.breadcrumb",
    path: `${APP_PREFIX_PATH}/components/navigation/breadcrumb`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation/breadcrumb")
    ),
  },
  {
    key: "components.navigation.dropdown",
    path: `${APP_PREFIX_PATH}/components/navigation/dropdown`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation/dropdown")
    ),
  },
  {
    key: "components.navigation.menu",
    path: `${APP_PREFIX_PATH}/components/navigation/menu`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation/menu")
    ),
  },
  {
    key: "components.navigation.pagination",
    path: `${APP_PREFIX_PATH}/components/navigation/pagination`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation/pagination")
    ),
  },
  {
    key: "components.navigation.steps",
    path: `${APP_PREFIX_PATH}/components/navigation/steps`,
    component: React.lazy(() =>
      import("views/app-views/components/navigation/steps")
    ),
  },
  {
    key: "components.data-entry",
    path: `${APP_PREFIX_PATH}/components/data-entry`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry")
    ),
  },
  {
    key: "components.data-entry.auto-complete",
    path: `${APP_PREFIX_PATH}/components/data-entry/auto-complete`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/auto-complete")
    ),
  },
  {
    key: "components.data-entry.cascader",
    path: `${APP_PREFIX_PATH}/components/data-entry/cascader`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/cascader")
    ),
  },
  {
    key: "components.data-entry.checkbox",
    path: `${APP_PREFIX_PATH}/components/data-entry/checkbox`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/checkbox")
    ),
  },
  {
    key: "components.data-entry.date-picker",
    path: `${APP_PREFIX_PATH}/components/data-entry/date-picker`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/date-picker")
    ),
  },
  {
    key: "components.data-entry.form",
    path: `${APP_PREFIX_PATH}/components/data-entry/form`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/form")
    ),
  },
  {
    key: "components.data-entry.input",
    path: `${APP_PREFIX_PATH}/components/data-entry/input`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/input")
    ),
  },
  {
    key: "components.data-entry.input-number",
    path: `${APP_PREFIX_PATH}/components/data-entry/input-number`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/input-number")
    ),
  },
  {
    key: "components.data-entry.mentions",
    path: `${APP_PREFIX_PATH}/components/data-entry/mentions`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/mentions")
    ),
  },
  {
    key: "components.data-entry.radio",
    path: `${APP_PREFIX_PATH}/components/data-entry/radio`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/radio")
    ),
  },
  {
    key: "components.data-entry.rate",
    path: `${APP_PREFIX_PATH}/components/data-entry/rate`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/rate")
    ),
  },
  {
    key: "components.data-entry.select",
    path: `${APP_PREFIX_PATH}/components/data-entry/select`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/select")
    ),
  },
  {
    key: "components.data-entry.slider",
    path: `${APP_PREFIX_PATH}/components/data-entry/slider`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/slider")
    ),
  },
  {
    key: "components.data-entry.switch",
    path: `${APP_PREFIX_PATH}/components/data-entry/switch`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/switch")
    ),
  },
  {
    key: "components.data-entry.time-picker",
    path: `${APP_PREFIX_PATH}/components/data-entry/time-picker`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/time-picker")
    ),
  },
  {
    key: "components.data-entry.transfer",
    path: `${APP_PREFIX_PATH}/components/data-entry/transfer`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/transfer")
    ),
  },
  {
    key: "components.data-entry.tree-select",
    path: `${APP_PREFIX_PATH}/components/data-entry/tree-select`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/tree-select")
    ),
  },
  {
    key: "components.data-entry.upload",
    path: `${APP_PREFIX_PATH}/components/data-entry/upload`,
    component: React.lazy(() =>
      import("views/app-views/components/data-entry/upload")
    ),
  },
  {
    key: "components.data-display",
    path: `${APP_PREFIX_PATH}/components/data-display`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display")
    ),
  },
  {
    key: "components.data-display.avatar",
    path: `${APP_PREFIX_PATH}/components/data-display/avatar`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/avatar")
    ),
  },
  {
    key: "components.data-display.badge",
    path: `${APP_PREFIX_PATH}/components/data-display/badge`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/badge")
    ),
  },
  {
    key: "components.data-display.calendar",
    path: `${APP_PREFIX_PATH}/components/data-display/calendar`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/calendar")
    ),
  },
  {
    key: "components.data-display.card",
    path: `${APP_PREFIX_PATH}/components/data-display/card`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/card")
    ),
  },
  {
    key: "components.data-display.carousel",
    path: `${APP_PREFIX_PATH}/components/data-display/carousel`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/carousel")
    ),
  },
  {
    key: "components.data-display.collapse",
    path: `${APP_PREFIX_PATH}/components/data-display/collapse`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/collapse")
    ),
  },
  {
    key: "components.data-display.comment",
    path: `${APP_PREFIX_PATH}/components/data-display/comment`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/comment")
    ),
  },
  {
    key: "components.data-display.descriptions",
    path: `${APP_PREFIX_PATH}/components/data-display/descriptions`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/descriptions")
    ),
  },
  {
    key: "components.data-display.empty",
    path: `${APP_PREFIX_PATH}/components/data-display/empty`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/empty")
    ),
  },
  {
    key: "components.data-display.list",
    path: `${APP_PREFIX_PATH}/components/data-display/list`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/list")
    ),
  },
  {
    key: "components.data-display.popover",
    path: `${APP_PREFIX_PATH}/components/data-display/popover`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/popover")
    ),
  },
  {
    key: "components.data-display.statistic",
    path: `${APP_PREFIX_PATH}/components/data-display/statistic`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/statistic")
    ),
  },
  {
    key: "components.data-display.table",
    path: `${APP_PREFIX_PATH}/components/data-display/table`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/table")
    ),
  },
  {
    key: "components.data-display.tabs",
    path: `${APP_PREFIX_PATH}/components/data-display/tabs`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/tabs")
    ),
  },
  {
    key: "components.data-display.tag",
    path: `${APP_PREFIX_PATH}/components/data-display/tag`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/tag")
    ),
  },
  {
    key: "components.data-display.timeline",
    path: `${APP_PREFIX_PATH}/components/data-display/timeline`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/timeline")
    ),
  },
  {
    key: "components.data-display.tooltip",
    path: `${APP_PREFIX_PATH}/components/data-display/tooltip`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/tooltip")
    ),
  },
  {
    key: "components.data-display.tree",
    path: `${APP_PREFIX_PATH}/components/data-display/tree`,
    component: React.lazy(() =>
      import("views/app-views/components/data-display/tree")
    ),
  },
  {
    key: "components.feedback",
    path: `${APP_PREFIX_PATH}/components/feedback`,
    component: React.lazy(() => import("views/app-views/components/feedback")),
  },
  {
    key: "components.feedback.alert",
    path: `${APP_PREFIX_PATH}/components/feedback/alert`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/alert")
    ),
  },
  {
    key: "components.feedback.drawer",
    path: `${APP_PREFIX_PATH}/components/feedback/drawer`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/drawer")
    ),
  },
  {
    key: "components.feedback.message",
    path: `${APP_PREFIX_PATH}/components/feedback/message`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/message")
    ),
  },
  {
    key: "components.feedback.modal",
    path: `${APP_PREFIX_PATH}/components/feedback/modal`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/modal")
    ),
  },
  {
    key: "components.feedback.notification",
    path: `${APP_PREFIX_PATH}/components/feedback/notification`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/notification")
    ),
  },
  {
    key: "components.feedback.popconfirm",
    path: `${APP_PREFIX_PATH}/components/feedback/popconfirm`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/popconfirm")
    ),
  },
  {
    key: "components.feedback.progress",
    path: `${APP_PREFIX_PATH}/components/feedback/progress`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/progress")
    ),
  },
  {
    key: "components.feedback.result",
    path: `${APP_PREFIX_PATH}/components/feedback/result`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/result")
    ),
  },
  {
    key: "components.feedback.skeleton",
    path: `${APP_PREFIX_PATH}/components/feedback/skeleton`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/skeleton")
    ),
  },
  {
    key: "components.feedback.spin",
    path: `${APP_PREFIX_PATH}/components/feedback/spin`,
    component: React.lazy(() =>
      import("views/app-views/components/feedback/spin")
    ),
  },
  {
    key: "components.other",
    path: `${APP_PREFIX_PATH}/components/other`,
    component: React.lazy(() => import("views/app-views/components/other")),
  },
  {
    key: "components.other",
    path: `${APP_PREFIX_PATH}/components/other`,
    component: React.lazy(() => import("views/app-views/components/other")),
  },
  {
    key: "components.other",
    path: `${APP_PREFIX_PATH}/components/other`,
    component: React.lazy(() => import("views/app-views/components/other")),
  },
  {
    key: "components.other.anchor",
    path: `${APP_PREFIX_PATH}/components/other/anchor`,
    component: React.lazy(() =>
      import("views/app-views/components/other/anchor")
    ),
  },
  {
    key: "components.other.backtop",
    path: `${APP_PREFIX_PATH}/components/other/backtop`,
    component: React.lazy(() =>
      import("views/app-views/components/other/backtop")
    ),
  },
  {
    key: "components.other.config-provider",
    path: `${APP_PREFIX_PATH}/components/other/config-provider`,
    component: React.lazy(() =>
      import("views/app-views/components/other/config-provider")
    ),
  },
  {
    key: "components.other.divider",
    path: `${APP_PREFIX_PATH}/components/other/divider`,
    component: React.lazy(() =>
      import("views/app-views/components/other/divider")
    ),
  },
  {
    key: "components.chart",
    path: `${APP_PREFIX_PATH}/components/charts`,
    component: React.lazy(() => import("views/app-views/components/charts")),
  },
  {
    key: "components.chart.apex-charts",
    path: `${APP_PREFIX_PATH}/components/charts/apex-charts`,
    component: React.lazy(() =>
      import("views/app-views/components/charts/apex")
    ),
  },
  {
    key: "components.chart.chartjs",
    path: `${APP_PREFIX_PATH}/components/charts/chartjs`,
    component: React.lazy(() =>
      import("views/app-views/components/charts/chartjs")
    ),
  },
  {
    key: "components.maps",
    path: `${APP_PREFIX_PATH}/components/maps`,
    component: React.lazy(() => import("views/app-views/components/maps")),
  },
  {
    key: "components.maps.simple-map",
    path: `${APP_PREFIX_PATH}/components/maps/simple-map`,
    component: React.lazy(() =>
      import("views/app-views/components/maps/simple-map")
    ),
  },
  {
    key: "login-1",
    path: `${APP_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-1")
    ),
    meta: {
      blankLayout: true,
    },
  },
  //   {
  //     key: "login-2",
  //     path: `${APP_PREFIX_PATH}/login-2`,
  //     component: React.lazy(() =>
  //       import("views/auth-views/authentication/login-2")
  //     ),
  //     meta: {
  //       blankLayout: true,
  //     },
  //   },
  {
    key: "register-1",
    path: `${APP_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-1")
    ),
    meta: {
      blankLayout: true,
    },
  },
  //   {
  //     key: "register-2",
  //     path: `${APP_PREFIX_PATH}/register-2`,
  //     component: React.lazy(() =>
  //       import("views/auth-views/authentication/register-2")
  //     ),
  //     meta: {
  //       blankLayout: true,
  //     },
  //   },
  {
    key: "forgot-password",
    path: `${APP_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "error-page-1",
    path: `${APP_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "error-page-2",
    path: `${APP_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "pages",
    path: `${APP_PREFIX_PATH}/pages`,
    component: React.lazy(() => import("views/app-views/pages")),
  },
  {
    key: "pages.profile",
    path: `${APP_PREFIX_PATH}/pages/profile`,
    component: React.lazy(() => import("views/app-views/pages/profile")),
    meta: {
      allowedRoles: ["truck_owner", "mechanic", "fleet_manager", "driver"],
    },
  },
  {
    key: "pages.invoice",
    path: `${APP_PREFIX_PATH}/pages/invoice`,
    component: React.lazy(() => import("views/app-views/pages/invoice")),
    meta: {
      allowedRoles: ["truck_owner", "mechanic", "fleet_manager", "driver"],
    },
  },
  {
    key: "pages.pricing",
    path: `${APP_PREFIX_PATH}/pages/pricing`,
    component: React.lazy(() => import("views/app-views/pages/pricing")),
  },
  {
    key: "pages.faq",
    path: `${APP_PREFIX_PATH}/pages/faq`,
    component: React.lazy(() => import("views/app-views/pages/faq")),
  },
  {
    key: "pages.setting",
    path: `${APP_PREFIX_PATH}/pages/setting/*`,
    component: React.lazy(() => import("views/app-views/pages/setting")),
    meta: {
      allowedRoles: ["truck_owner", "mechanic", "fleet_manager", "driver"],
    },
  },
  {
    key: "mechanic.settings",
    path: `${APP_PREFIX_PATH}/mechanic/settings/*`,
    component: React.lazy(() => import("views/app-views/mechanic/settings")),
    meta: { allowedRoles: ["mechanic"] },
  },
  {
    key: "pages.user-list",
    path: `${APP_PREFIX_PATH}/pages/user-list`,
    component: React.lazy(() => import("views/app-views/pages/user-list")),
  },
  {
    key: "docs.documentation",
    path: `${APP_PREFIX_PATH}/docs/documentation/*`,
    component: React.lazy(() => import("views/app-views/docs")),
  },
];
